import { useMutation } from '../lib/query';
import { loadDraft, removeDestinations, submitDraft } from '../services/moderateDestinations';

// The draft is held in page state (removal returns the refreshed set), so these
// are plain mutations rather than cached queries.
export const useLoadDraft = (opts = {}) =>
  useMutation({ mutationFn: (type) => loadDraft(type), onSuccess: opts.onSuccess, onError: opts.onError });

export const useRemoveDestinations = (opts = {}) =>
  useMutation({
    mutationFn: ({ type, cities }) => removeDestinations(type, cities),
    onSuccess: opts.onSuccess,
    onError: opts.onError,
  });

export const useSubmitDraft = (opts = {}) =>
  useMutation({ mutationFn: (type) => submitDraft(type), onSuccess: opts.onSuccess, onError: opts.onError });
